import Lottie from 'lottie-react';

import specialists from '../jsons/Specialists.json';

const Specialists = props => {
  return <Lottie animationData={specialists} {...props} />;
};

export default Specialists;
